import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import TheMath from '../components/TheMath';
import TheCatch from '../components/TheCatch';
import CTAButton from '../components/CTAButton';
import SEO from '../components/SEO';

export default function Home({ lang }) {
  const seoData = {
    en: {
      title: '10 Beers for 15€ - Local Taproom Pass',
      description: 'The ultimate local beer pass. Valid at 10 top taprooms. 10 beers total for only 15€. Limited to 100 passes. No bullshit.'
    },
    es: {
      title: '10 Cervezas por 15€ - Pase Cervecero Local',
      description: 'El mejor pase de cerveza local. Válido en 10 cervecerías top. 10 cervezas por solo 15€. Limitado a 100 pases. Sin excusas.'
    }
  };

  const currentSeo = seoData[lang];

  return (
    <div className="flex flex-col items-center w-full">
      <SEO 
        title={currentSeo.title} 
        description={currentSeo.description} 
        lang={lang} 
      />
      <Hero lang={lang} />
      <HowItWorks lang={lang} />
      <TheMath lang={lang} />
      <TheCatch lang={lang} />
      
      <div className="w-full mt-16 pt-16 border-t-8 border-white">
        <h2 className="text-3xl font-black uppercase mb-8 text-center">
          {lang === 'en' ? 'Ready to drink?' : '¿Listo para beber?'}
        </h2>
        <CTAButton lang={lang} />
      </div>
    </div>
  );
}